import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationReviewItem } from 'app/models/dto/borrower-fd/application-review.model';

@Pipe({ name: 'tooltiplist' })
export class TooltipListPipe implements PipeTransform {

  transform(lines: ApplicationReviewItem[]): string {

    let list: string = 'Missing Items:\n';

    lines.forEach(line => {
      list += '• ' + line.name + '\n';
    });

    return list;
  }
}
